import Config from '@config';
import { initializeLocationsApi } from '@gasbi/shared/common/features/locations';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const {
  locationsApi,
  useGetSettlementsQuery,
  useGetStreetsQuery,
  useGetBuildingTypesGridifyInfiniteQuery,
} = initializeLocationsApi({
  baseUrl: Config.VITE_API_URL,
  baseQuery: axiosBaseQuery,
});
